import { inject } from '@angular/core';
import { HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { SKIP_CONFIRMATION, ConfirmDialogComponent } from '../ui/confirm-dialog/confirm-dialog';
import { CustomHeader } from '../models/header.enum';
import { ActionType } from '../../shared/models/table-column.model';

export const confirmDeleteInterceptor: HttpInterceptorFn = (req, next) => {
    const dialog = inject(MatDialog);
    let skipConfirmation = localStorage.getItem(SKIP_CONFIRMATION) === 'true' || false;;
    
    if (req.headers.has(CustomHeader.SkipDeleteConfirmation)) {
        req = req.clone({ headers: req.headers.delete(CustomHeader.SkipDeleteConfirmation) });
        skipConfirmation = true;
    }

    if (req.method === 'DELETE' && !skipConfirmation) {
        return dialog.open(ConfirmDialogComponent, { data: { message: 'app.confirmDelete', action: ActionType.Delete }, autoFocus: false })
            .afterClosed()
            .pipe(
                switchMap(confirmed => confirmed ? next(req) : new Observable<HttpEvent<unknown>>())
            );
    }

    return next(req);
}

